import React from "react";
import {useTheme} from "connectui/theme/ThemeProvider";
import Tooltip from "connectui/component/display/Tooltip";
import FlexContainer from "connectui/component/layout/FlexContainer";
import Text from "connectui/component/display/Text";
import SvgIcon from "connectui/component/display/SvgIcon";
import ICONS from "connectui/icons/iconMap";

const AutopilotTooltip = ({message, className}) => {
  const {theme} = useTheme();

  return (
    <Tooltip
      tooltipContent={
        <FlexContainer flexDirection="column" gap={theme.spacing(1)}>
          {message?.tags?.autoresponder_failure_reasons?.length > 0 && (
            <Text variant="textSM" color="textPrimary">
              Autopilot Failure Reasons:
              {message.tags.autoresponder_failure_reasons.map(
                (reason, index) => (
                  <Text key={index} variant="textSM" color="textSecondary">
                    • {reason}
                  </Text>
                ),
              )}
            </Text>
          )}
          {message.delivery_state === "pending" && (
            <Text variant="textSM" color="textPrimary">
              Delivery State: Pending
            </Text>
          )}
        </FlexContainer>
      }
    >
      <SvgIcon
        component={ICONS.ai}
        className={className}
        sx={{
          color: theme.colors.textSecondary,
        }}
      />
    </Tooltip>
  );
};

export default AutopilotTooltip;
